"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_js_1 = require("../utils.js");
(0, utils_js_1.whenReady)(function () { return __awaiter(void 0, void 0, void 0, function () {
    function toggleMenu() {
        menu.classList.toggle("menu_active");
        menuButton.classList.toggle("menu-button_active");
        header.classList.toggle("header_active");
        document.body.classList.toggle('overflow-hidden-md');
    }
    var menuButton, menu, header, _loop_1, _i, _a, copyInput;
    var _b;
    return __generator(this, function (_c) {
        menuButton = document.querySelector(".menu-button");
        menu = document.querySelector(".menu");
        header = document.querySelector(".header");
        menuButton.addEventListener("click", toggleMenu);
        header.addEventListener("click", function (e) {
            var target = e.target;
            if (header.classList.contains("header_active")
                && target instanceof HTMLElement
                && target.classList.contains("menu__link")) {
                toggleMenu();
            }
        });
        document.querySelectorAll("[data-play]").forEach(function (playButton) {
            playButton.addEventListener("click", function (event) {
                var button = event.target;
                if (button instanceof HTMLElement) {
                    var playUrl = button.getAttribute("data-play");
                    var overlay_1 = document.createElement("div");
                    overlay_1.classList.add("overlay");
                    var container = document.createElement("div");
                    container.classList.add("video-container");
                    overlay_1.appendChild(container);
                    var iframeContainer = document.createElement("div");
                    iframeContainer.classList.add("iframe-container");
                    container.appendChild(iframeContainer);
                    var iframe = document.createElement("iframe");
                    iframe.classList.add("iframe-container__video");
                    iframe.setAttribute("src", "https://www.youtube.com/embed/".concat(playUrl, "?autoplay=1"));
                    iframe.setAttribute("iframeborder", "0");
                    iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
                    iframe.setAttribute("allowfullscreen", "allowfullscreen");
                    iframeContainer.appendChild(iframe);
                    document.body.appendChild(overlay_1);
                    overlay_1.addEventListener("click", function () {
                        document.body.removeChild(overlay_1);
                    });
                }
            });
        });
        _loop_1 = function (copyInput) {
            (_b = copyInput.parentElement.querySelector(".input-copy__btn")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, utils_js_1.copyToClipBoard)(copyInput.getAttribute("value"))];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        for (_i = 0, _a = Array.from(document.querySelectorAll(".input-copy__input")); _i < _a.length; _i++) {
            copyInput = _a[_i];
            _loop_1(copyInput);
        }
        return [2 /*return*/];
    });
}); });
